import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-error402',
    templateUrl: './error402.component.html',
    styleUrls: ['./error402.component.scss'],
    imports: [RouterLink, TranslatePipe]
})
export class Error402Component implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
